export const openTabAndFocus = (url: string) => {
  const newWindow = window.open(url, '_blank')

  if (!newWindow) {
    return
  }

  newWindow.focus()
}
